import { dayjs } from '@convenia/utils'

export default () => ({
  educationTypeId: {
    type: 'select',
    label: 'Escolaridade',
    placeholder: 'Escolaridade',
    options: [],
    displayBy: 'name',
    trackBy: 'id',
    infoCardProps: { hide: true },
  },

  institution: {
    type: 'text',
    label: 'Instituição de ensino',
    placeholder: 'Instituição de ensino',
    validation: '',
  },

  course: {
    type: 'text',
    label: 'Curso',
    placeholder: 'Curso',
    validation: '',
  },

  graduationYear: {
    type: 'text',
    inputmode: 'numeric',
    label: 'Ano de conclusão',
    placeholder: 'Ano de conclusão',
    validation: {
      min: 4,
      custom: (_, value) => {
        if (!value.length) return true

        return dayjs(value, 'YYYY', true).isValid() &&
          dayjs(value, 'YYYY').isAfter(dayjs('1900', 'YYYY'))
      }
    },
    validationMsg: ({ graduationYear }) => {
      if (graduationYear.length < 4) return 'Ano de conclusão deve ter 4 dígitos'
      if (Number(graduationYear) < 1900) return 'Ano de conclusão deve ser um ano válido'
    },
    emitPreValidation: true,
    mask: '####',
    value: '',
  },

  documentFiles: {
    type: 'file',
    label: '',
    showLabel: false,
    multiple: true,
    labelLeft: false,
    fullWidth: true,
    extensions: [
      'jpg',
      'jpeg',
      'gif',
      'bmp',
      'png',
      'pdf',
    ],
    infoCardProps: { hide: true },
    fileLimit: 4,
    validation: { maxLength: 4 },
    sizeLimit: 8,
  },
})
